import {useBusinessInfo} from "~/lib/Queries";
import {setBusinessId} from "~/lib/Api";
import * as Toast from "~/lib/Toast";

export const ACCESS_FULL = 'full';
export const ACCESS_LIMITED = 'limited';


const usePermissions = () =>
{
    const { data } = useBusinessInfo();

    const permissionData = data?.business?.pivot?.permissions || {};
    const level = permissionData?.role || ACCESS_FULL;

    function can(permission)
    {
        if (level === ACCESS_FULL) {
            return true;
        } else {
            return (permissionData?.permissions||[]).indexOf(permission) > -1;
        }
    }

    /**
     * Some things aren't grantable - a limited user can't be given them at
     *  all. Writing a custom question is one: it is code that runs on the
     *  business's own client-facing forms. Matches
     *  UserPermissions::FULL_ACCESS_ONLY on the server
     */
    function isFullAccess()
    {
        return level === ACCESS_FULL;
    }

    return {
        can,
        isFullAccess
    }
}

export default usePermissions;
